export const updateDashboardValues = (state = {}, action) => {
    const { type } = action;

    switch(type) {
        case 'FETCH_DASHBOARD':
            return action.payload
        default:
            return state
    }
}